import Util from './Util';
import Locale from './Locale';

export default class FileUtils {
    static getRoutingKey(adv) {
        if (adv) {
            return 'adv';
        }
        if (Util.getURLparameter('mars-upload-test')) {
            return 'test';
        }
        return 'web';
    }

    static buildUploadFileErrorMessage(listOfErrorLabels) {
        if (!listOfErrorLabels || !listOfErrorLabels.length) {
            return null;
        }
        let message = `${Locale.getText('INVALID')} `;
        const LAST_IDX = listOfErrorLabels.length - 1;

        listOfErrorLabels.forEach((label, idx) => {
            if (idx === LAST_IDX && LAST_IDX > 0) {
                message += `${Locale.getText('AND')} `;
            }
            message += Locale.getText(label);
            if (idx < LAST_IDX - 1) {
                message += ', ';
            } else if (idx === LAST_IDX - 1) {
                message += ' ';
            }
        });
        return `${message}.`;
    }

    // convert image data (to Blob) to File having name b64FileName
    static base64ToFile(data, b64FileName) {
        const rImageType = /data:(image\/.+);base64,/;
        let mimeString = '';
        let raw;
        let uInt8Array;
        let i;

        raw = data.replace(rImageType, (header, imageType) => {
            mimeString = imageType;

            return '';
        });

        raw = atob(raw);
        const rawLength = raw.length;
        uInt8Array = new Uint8Array(rawLength); // eslint-disable-line

        for (i = 0; i < rawLength; i += 1) {
            uInt8Array[i] = raw.charCodeAt(i);
        }

        const blob = new Blob([uInt8Array], {type: mimeString});
        return new File([blob], b64FileName, {type: mimeString});
    }

    static getCroppedImg(image, crop, label, targetAspectRatio = null) {
        const canvas = document.createElement('canvas');
        const sourceWidth = (crop.width / 100) * image.naturalWidth;
        const sourceHeight = (crop.height / 100) * image.naturalHeight;
        const calculatedHeight = Math.round(sourceHeight);
        let calculatedWidth = Math.round(sourceWidth);

        if (targetAspectRatio) {
            const currentRatio = calculatedWidth / calculatedHeight;
            // Adjust width to maintain the target ratio
            if (Math.abs(currentRatio - targetAspectRatio) > 0.01) {
                calculatedWidth = Math.round(calculatedHeight * targetAspectRatio);
            }
        }

        canvas.width = calculatedWidth;
        canvas.height = calculatedHeight;
        const ctx = canvas.getContext('2d');

        ctx.drawImage(
            image,
            (crop.x / 100) * image.naturalWidth,
            (crop.y / 100) * image.naturalHeight,
            sourceWidth,
            sourceHeight,
            0,
            0,
            calculatedWidth,
            calculatedHeight
        );

        const base64Image = canvas.toDataURL();
        return this.base64ToFile(base64Image, Util.suggestedFilename(label, calculatedWidth, calculatedHeight));
    }

    static approximatelyEqual(v1, v2, epsilon = 0.001) {
        return Math.abs(v1 - v2) < epsilon;
    }

    static getImageAspectRatio(width, height) {
        let ratio;
        const allowedRatios = {
            [4 / 1]: '4:1',
            [4 / 3]: '4:3',
            [10 / 1]: '10:1',
            [9 / 16]: '9:16'
        };

        Object.keys(allowedRatios).forEach(key => {
            if (this.approximatelyEqual(key, width / height, 0.01)) {
                ratio = allowedRatios[key];
            }
        });

        return ratio;
    }

    static getExtension(filename) {
        if (!filename || !filename.includes('.')) {
            return undefined;
        }
        return filename.substring(filename.lastIndexOf('.') + 1);
    }

    static getBase(filename) {
        if (!filename || !filename.includes('.')) {
            return filename;
        }
        return filename.substring(0, filename.lastIndexOf('.'));
    }

    static getDimensionPart(filename) {
        const pattern = /-[0-9]+x[0-9]+$/;
        const match = filename.match(pattern);
        return match ? match[0] : '';
    }

    // ported from media-asset-routing-system AssetProcessorUtils
    static truncateFilename(filename, maxLength) {
        if (!filename || filename.length <= maxLength) {
            return filename;
        }
        const extension = FileUtils.getExtension(filename);
        const base = FileUtils.getBase(filename);
        const hasExtension = extension !== undefined;
        if (hasExtension && extension.length + 1 > maxLength) {
            const dimensionPart = FileUtils.getDimensionPart(base);
            let truncatedExtension = `${dimensionPart}.${extension.substring(0, maxLength - dimensionPart.length - 1)}`;
            if (truncatedExtension.includes('%')) {
                truncatedExtension = truncatedExtension.substring(0, truncatedExtension.lastIndexOf('%'));
            }
            return truncatedExtension;
        }
        const maxBaseLength = hasExtension ? maxLength - extension.length - 1 : maxLength;
        const dimensionPart = FileUtils.getDimensionPart(base);
        let trunk = base.substring(0, maxBaseLength - dimensionPart.length);
        // make sure we aren't breaking a % entity in the middle.
        if (trunk.includes('%')) {
            trunk = trunk.substring(0, trunk.lastIndexOf('%'));
        }
        trunk += dimensionPart;
        return hasExtension ? `${trunk}.${extension}` : trunk;
    }
}
